<template>
  <section id="add-user">
      <main style="text-align:left;white-space:normal">
        <div class="title">
            <icon icoClass='title-ico' selected='users'/>
            {{ $t('add_user') }}
        </div>
        <div class="fields">
            <div class="field-half-page">
                <label>{{ $t('firstname') }}</label>
                <input type="text" v-model="user.user.first_name" :readonly="$route.params.id"/>
            </div>
            <div class="field-half-page">
                <label>{{ $t('lastname') }}</label>
                <input type="text" v-model="user.user.last_name" :readonly="$route.params.id"/>
            </div>
            <div class="field-half-page">
                <label>{{ $t('username') }}<span class="mandatory">*</span></label>
                <input type="text" v-model="user.user.username" :readonly="$route.params.id"/>
            </div>
            <div class="field-half-page">
                <label>{{ $t('email') }}</label>
                <input type="text" v-model="user.user.email" :readonly="$route.params.id"/>
            </div>
            <div class="field-half-page" v-if="!$route.params.id">
                <label>{{ $t('pass') }}<span class="mandatory">*</span></label>
                <input type="password" v-model="user.user.password"/>
            </div>
            <div class="field-half-page" v-if="!$route.params.id">
                <label>{{ $t('repeat_pass') }}<span class="mandatory">*</span></label>
                <input type="password" v-model="password2"/>
            </div>
            <div class="field">
              <div class="field-half-page">
                <label>{{ $t('roles') }}<span class="mandatory">*</span></label>
                  <span class="custom-dropdown multiple"><select multiple v-model="user.roles">
                    <option v-for="(rol, index) in roles" :key="index" :value="rol">
                        {{ rol.description }}
                    </option>
                </select></span>
              </div>
            </div>
            <button class="btn-green" @click="save()">{{ $t('save') }}</button>
            <button class="btn-black" @click="$router.push('/users')">{{ $t('cancel') }}</button>
        </div>
      </main>
    </section>
</template>
<script>
import AddClient from './../components/Client'
import AddTruck from './../components/Truck'
import Modal from './../components/Modal'
import {mapActions, mapState} from 'vuex'
import icon from './../svg/tabs'
export default {
  name: 'addexp',
  components: {
    AddClient,
    AddTruck,
    Modal,
    icon
  },
  props: {
  },
  created () {
    this.$emit('loading')
  },
  mounted () {
    const promises = [
      this.getCompanies().then(response => {
        this.companies = response
      }),
      this.getRoles().then(response => {
        this.roles = response
      }),
      this.checkPermissions(['createMasters', 'seeHistory', 'justClientNotes', 'justCompanyNotes', 'onlyTruckHours', 'addTruck']).then(response => {
        this.canCreateMasters = response.createMasters
        this.canSeeHistory = response.seeHistory
        this.editJustNotes = !response.justClientNotes
        this.editJustCompNotes = !response.justCompanyNotes
        this.editJustTrucksHours = !response.onlyTruckHours
        this.canAddTruck = response.addTruck
      })
    ]
    if (this.$route.params && this.$route.params.id) {
      promises.push(this.getUser(this.$route.params.id).then(response => {
        this.user = response
      }))
    } else {
      promises.push(
        this.getTrucks().then(response => {
          this.trucks = response
        })
      )
    }
    Promise.all(promises).then(data => { this.$emit('loaded') })
  },
  data () {
    return {
      user: {user: {}, roles: []},
      roles: [],
      companies: [],
      showClient: false,
      showTruck: false,
      canAddTruck: false,
      password: ''
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth
    })
  },
  methods: {
    ...mapActions({
      checkPermissions: 'auth/checkPermissions',
      getCompanies: 'companies/list',
      modifyUser: 'user/modify',
      getRoles: 'roles/list',
      addUser: 'user/add',
      getUser: 'user/read'
    }),
    save () {
      if (!this.$route.params.id) {
        if (!this.user.user.password || !this.password2 || this.user.roles.length === 0 || !this.user.user.username) {
          this.$notify({ group: 'global', type: 'error', duration: 4000, title: 'Warning', text: this.$t('fill_mandatory') })
          return
        }
        if (this.user.user.password !== this.password2) {
          this.$notify({ group: 'global', type: 'error', duration: 4000, title: 'Warning', text: this.$t('pass_match') })
          return
        }
        // eslint-disable-next-line
        this.user.groups = this.companies.filter(c => c.id == this.auth.company)
        this.addUser(this.user).then(response => {
          this.$router.push('/users')
        })
      } else {
        this.modifyUser({roles: this.user.roles, id: this.user.id})
      }
    }
  }
}
</script>

<style scoped lang="scss">
#add-truck {
  display: table;
  min-width: 50%;
}
input, textarea {
  width: 100%;
  box-sizing: border-box;

}
textarea{
  resize: vertical;
}
.fields {
  padding: 0 3em;
}
.field-half-page {
  display: inline-block;
  width: 49.5%;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/pages/PageUser.vue